import React, {useEffect, useState} from 'react';
import parse from "html-react-parser";
import { useForm } from 'react-hook-form';
import { getDecimal } from "../config/utils";
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import FormControl from "@mui/material/FormControl";
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import { NumericFormat } from "react-number-format";
import ReplayIcon from "@mui/icons-material/Replay";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import {useSxStyles as sx} from "../styles/sxStyles";
import FormLabel from "@mui/material/FormLabel";
import Grid2 from '@mui/material/Grid2';

const AddFee = (props) => {
    const payableFee = props.payableFee;
    const addSelected = props.addSelected;
    const cancelAdd = props.cancelAdd;
    const {register, handleSubmit} = useForm();
    const [itemAmount, setItemAmount] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [totalAmt, setTotalAmt] = useState(0);

    const quantityChanged = (e) => {
        let qty = 0;
        const qtyVal = e.target.value;
        if (qtyVal) qty = parseInt(qtyVal);
        setQuantity(qty);
        if (qty > 0 && itemAmount > 0) {
            setTotalAmt(qty * itemAmount);
        } else {
            setTotalAmt(0);
        }
    }

    const itemAmtChanged = (values) => {
        if (values) {
            const amt = values.floatValue;
            setItemAmount(amt);
            if (quantity > 0) {
                setTotalAmt(amt * quantity);
            } else {
                setTotalAmt(0);
            }
        } else {
            setTotalAmt(getDecimal(0))
        }
    }

    const addSelectedFee = (form) => {
        const newMiscFee = {
            key: Date.now(),
            cmsId: payableFee.cmsId,
            name: payableFee.name,
            amount: totalAmt,
            quantity: quantity,
            itemAmount: itemAmount,
            comments: form.comments,
            deliveryMethod: false
        }
        addSelected(newMiscFee);
    }

    useEffect(() => {
        const amt = payableFee.allowAmountEntry ? 0 : payableFee.amount;
        setItemAmount(amt);
        setQuantity(1);
        setTotalAmt(amt);
    }, [payableFee])

    return (<>
        <Typography variant='h6' component='h4' color='primary' sx={{fontSize: '1.2rem', marginTop: '1rem'}}>Add a Fee</Typography>
        <Paper elevation={3} sx={{...sx.tableContainer, padding: '1rem'}}>
            <Grid2
                container
                spacing={1}
                style={{width: '100%', fontSize: '.9rem'}}
            >
                <Grid2
                    size={{
                        xs: 6,
                        md: 3
                    }}>
                    <FormControl fullWidth {...register('feeName')}>
                        <FormLabel shrink='true' sx={sx.inputLabel}>
                            Fee Name
                        </FormLabel>
                        <TextField
                            name='name'
                            variant='outlined'
                            type='text'
                            value={payableFee.name}
                            readOnly={true}
                            slotProps={{
                                htmlInput: {sx: sx.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 6,
                        md: 3
                    }}>
                    <FormControl fullWidth {...register('enteredAmount')}>
                        <FormLabel shrink='true' sx={sx.inputLabel}>
                            {payableFee.allowAmountEntry ? 'Enter' : 'Fee'} Amount
                        </FormLabel>
                        <NumericFormat
                            id='amount'
                            name='enteredAmount'
                            customInput={TextField}
                            InputProps={{readOnly: !payableFee.allowAmountEntry, sx: {height: '2rem'}}}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            decimalScale={2}
                            decimalSeparator='.'
                            fixedDecimalScale={true}
                            value={itemAmount}
                            onValueChange={values => {itemAmtChanged(values)}}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 6,
                        md: 3
                    }}>
                    <FormControl fullWidth {...register('quantity')}>
                        <FormLabel htmlFor='quantity' shrink={true} sx={sx.inputLabel}>Quantity</FormLabel>
                        <TextField
                            name='quantity'
                            variant='outlined'
                            type='number'
                            value={quantity}
                            onChange={quantityChanged}
                            slotProps={{
                                htmlInput: {sx: sx.textbox}
                            }}
                        />
                    </FormControl>
                </Grid2>
                <Grid2
                    size={{
                        xs: 6,
                        md: 3
                    }}>
                    <FormControl fullWidth {...register('totalAmount')}>
                        <FormLabel shrink='true' sx={sx.inputLabel}>
                            Total Amount
                        </FormLabel>
                        <NumericFormat
                            id='total'
                            name='totalAmount'
                            customInput={TextField}
                            InputProps={{readOnly: true, sx: {height: '2rem'}}}
                            type='text'
                            autoComplete='off'
                            variant='outlined'
                            value={totalAmt}
                            decimalScale={2}
                            decimalSeparator='.'
                            fixedDecimalScale={true}
                        />
                    </FormControl>
                </Grid2>
                { payableFee.entryInstructions &&
                    <>
                        <Grid2
                            sx={{marginTop: '.8rem'}}
                            size={{
                                xs: 4,
                                md: 3
                            }}>
                            <Typography variant='body1' component='h5' color='secondary'>Entry Instructions:</Typography>
                        </Grid2>
                        <Grid2
                            sx={{marginTop: '.8rem'}}
                            size={{
                                xs: 8,
                                md: 9
                            }}>
                            <Typography variant='subtitle2' color='primary' sx={{paddingTop: '2pt'}}>{parse(payableFee.entryInstructions)}</Typography>
                        </Grid2>
                    </>
                }
                <Grid2 sx={{paddingRight: '1rem'}} size={12}>
                    <TextField
                        label='Request Details'
                        aria-label='Request details'
                        fullWidth
                        multiline
                        rows={3}
                        sx={{margin: '1rem', resize: 'none'}}
                        {...register('comments')}
                        slotProps={{
                            htmlInput: {id: 'details', maxLength: 500, style: {fontSize: '.9rem'}},
                            inputLabel: {htmlFor: 'details', sx: sx.inputLabel, style: {fontSize: '.9rem'}}
                        }} />
                </Grid2>
                <Grid2 size={12} >
                    <Box component='span' sx={{display: 'flex', flexDirection: 'row-reverse'}}>
                        <Button
                            variant='contained'
                            color='primary'
                            startIcon={<AddShoppingCartIcon />}
                            sx={sx.squashedButton}
                            onClick={handleSubmit(addSelectedFee)}
                        >
                            Add Fee
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ReplayIcon/>}
                            sx={sx.squashedButton}
                            onClick={cancelAdd}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Grid2>
            </Grid2>
        </Paper>
    </>);
}

export default AddFee;
